import { SelectionItem } from '../../../core/component/select/select.component';

export enum LettingAdvertismentPlatformType {
  Internal = 0,
  HomeQ = 1,
  DhMarket = 2,
  BoplatsSverige = 3,
}
